import React from "react";
import { OTPublisher } from "opentok-react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Draggable from "react-draggable";

import { getUserData } from "../../../../utils/localStorage";
import * as actions from "../../../../store/actions";
import messages from "../../../../constants/messages";
import constants from "../../../../constants";

import Modals from "../../../../components/uiElements/popupModal/modal";
import Avatar from "react-avatar";
import Controls from "./Controls";
import StartCallIcon from "../../../../components/uiElements/icons/profileIcons/StartCallIcon";
import AutoCloseMenu from "../../../../layout/Dashboard/AutoCloseMenu";

class Publisher extends React.Component {
  constructor(props) {
    super(props);
    this.inputElement = undefined;
    this.state = {
      publisher: null,
      error: null,
      userAccessDenied: false,
      audio: true,
      video: true,
      menu: false,
      publisherId: undefined,
      isLeave: false,
    };

    this.name = getUserData()?.firstName + " " + getUserData()?.lastName;

    this.id = getUserData()?.id;

    this.publisherEventHandlers = {
      accessAllowed: event => {
        this.setState({
          userAccessDenied: false,
        });
      },
      accessDenied: event => {
        this.setState({
          userAccessDenied: true,
        });
      },
      streamCreated: event => {
        this.props.setPublisher(event.stream.id);
        this.setState({
          publisherId: event.stream.id,
        });
      },
      publisherError: event => {
        this.setState({error: event?.name});
        toast.error(messages.SOMTHING_WENT_WRONG, {position: constants.TOAST_POSITION});
      }
    };
  }

  onError = err => {
    if (err.name === "OT_USER_MEDIA_ACCESS_DENIED") {
      this.setState({
        userAccessDenied: true,
      });
    } else {
      toast.error(messages.SOMTHING_WENT_WRONG, {position: constants.TOAST_POSITION});
      this.setState({ error: `Failed to publish: ${err.message}` });
    }
  };

  handleFile = e => {
    const file = e.target.files;
    const maxAllowedSize = 5 * 1024 * 1024;
    if (file[0].size > maxAllowedSize) {
      toast.error(messages.MAX_FILE_SIZE, {
        position: constants.TOAST_POSITION,
      });
    } else {
      const uploadedFiles = Array.from(file);
      this.props.setSharedDocuments(uploadedFiles, location => {
        this.props.sendSignal(location);
        this.props.changeControl({
          chat: true,
          share: false,
        });
      });
    }
    e.target.value = null;
  };
  
  sendPermission = status => {
    const permissionObj = {
      status: status,
      type: "SCREEN_SHOT",
      id: this.id,
      streamId: this.state.publisherId,
    };
    this.props.sendPermissionSignal(
      JSON.stringify(permissionObj),
      "screenshot_permission_message"
    );
  };

  isPatientJoined() {
    return !!this.props?.users?.find(user =>
      ["PATIENT", "PARENT"].includes(user.type)
    );
  }

  viewProfile = () => {
    localStorage.setItem("viewMode", true);
    window.open(
      `${process.env.REACT_APP_URL}/dashboard/patients/detail/${
        this.props?.appointment?.patient_detail?.id ||
        this.props?.visitNow?.patient?.id
      }`,
      "_blank",
      "toolbar=no,scrollbars=no,resizable=yes,top=500,left=250,width=900,height=900"
    );
  };

  render() {
    return (
      <>
        <input
          ref={input => (this.inputElement = input)}
          accept="application/pdf,image/png,image/jpg,image/jpeg"
          type="file"
          style={{ display: "none" }}
          onChange={e => {
            this.handleFile(e);
          }}
        />
        <Modals
          isOpen={this.state.userAccessDenied || this.state.error}
          closeModal={() => {
            this.setState({
              userAccessDenied: false,
              error: undefined,
            });
          }}
          title={
            this.state.userAccessDenied ? (
              <span>
                <StartCallIcon type="videoBlocked" />
              </span>
            ) : (
              "Error"
            )
          }
          styles={{
            content: {
              minWidth: "350px",
              maxWidth: "350px",
              minHeight: "230px",
              maxHeight: "230px",
            },
          }}
        >
          <React.Fragment>
            <p className="mx-auto text-center denyAppointmentText">
              {(this.state.userAccessDenied && (
                <>
                  {" "}
                  Allow access to your cam/mic by clicking on blocked cam icon
                  in address bar <StartCallIcon type="permissionBlocked" /> and
                  reconnect{" "}
                </>
              )) ||
                this.state.error}
            </p>
          </React.Fragment>
        </Modals>

        <Modals
          isOpen={this.props.permission}
          title={"Allow Permission"}
          styles={{
            content: {
              minWidth: "400px",
              maxWidth: "400px",
              minHeight: "330px",
              maxHeight: "330px",
            },
          }}
          btnDark={{
            label: "Accept",
            onclick: () => {
              this.sendPermission("ACCEPTED");
            },
          }}
          btnOutline={{
            label: "Reject",
            onclick: () => {
              this.sendPermission("REJECTED");
            },
          }}
        >
          <React.Fragment>
            <p className="mx-auto text-center denyAppointmentText">
              {this.props.permission?.data?.name} requested for permission to
              take screenshot
            </p>
          </React.Fragment>
        </Modals>

        <Modals
          isOpen={this.state.isLeave}
          title={"End Call"}
          styles={{
            content: {
              minWidth: "400px",
              maxWidth: "400px",
              minHeight: "330px",
              maxHeight: "330px",
            },
          }}
          btnDark={{
            label: "Yes",
            onclick: () => {
              this.props.onDestroy();
            },
          }}
          btnOutline={{
            label: "No",
            onclick: () => {
              this.setState({
                isLeave: false,
              });
            },
          }}
        >
          <React.Fragment>
            <p className="mx-auto text-center denyAppointmentText">
              Are you sure do you want to end this call ?
            </p>
          </React.Fragment>
        </Modals>

        <Draggable
          axis="y"
          bounds={{ top: 1, bottom: window.innerHeight - 250 }}
        >
          <div
            className="publisher"
            style={{
              cursor: "grabbing",
            }}
          >
            <OTPublisher
              eventHandlers={this.publisherEventHandlers}
              className="publisher-video-stream"
              properties={{
                width: "100%",
                height: "100%",
                insertMode: "append",
                publishAudio: this.state.audio,
                publishVideo: this.state.video,
                videoSource:
                  this.state.videoSource === "screen" ? "screen" : undefined,
                name: this.name,
                fitMode: "cover",
                showControls: true,
                style: {
                  backgroundImageURI: "undefined",
                  nameDisplayMode: "off",
                  buttonDisplayMode: "off",
                  audioLevelDisplayMode: "off",
                },
              }}
              onError={this.onError}
            />
            {!this.state.video && (
              <div className="center-element">
                <Avatar
                  src={this.props?.profileImage}
                  name={this.name}
                  size={100}
                  round={true}
                  maxInitials={2}
                />
              </div>
            )}
          </div>
        </Draggable>
        {this.props.connected && (
          <div className="publisherControls content-center">
            <div className="px-5">
              <Controls
                label="Chat"
                control="chat"
                isSignalReceived={this.props?.signalReceived}
                isChecked={this.props.control?.chat}
                onChange={() => {
                  if (this.props.noOfUsersConnected > 0) {
                    this.props.changeControl({
                      chat: !this.props.control?.chat,
                      notes: false,
                      addParticipants: false,
                      showVitals: false,
                      prescriptions: false,
                    });
                    this.props.onSetSignalReceived();
                  }
                }}
              />
              <Controls
                label="Notes"
                control="notes"
                isChecked={this.props.control?.notes}
                onChange={() =>
                  this.props.noOfUsersConnected > 0 &&
                  this.isPatientJoined() &&
                  this.props.changeControl({
                    notes: !this.props.control?.notes,
                    chat: false,
                    addParticipants: false,
                    showVitals: false,
                    prescriptions: false,
                  })
                }
              />
              <Controls
                label="Share"
                control="share"
                isChecked={this.props.control?.share}
                onChange={() => {
                  if (this.props.noOfUsersConnected > 0) {
                    this.inputElement.click();
                    this.props.changeControl({
                      share: !this.props.control?.share,
                    });
                  }
                }}
              />
            </div>
            <div className="px-5">
              <Controls
                label={
                  this.state.audio
                    ? "Turn off microphone"
                    : "Turn on microphone"
                }
                control={this.state.audio ? "audioOn" : "audioOff"}
                isChecked={this.state.audio}
                onChange={() =>
                  this.setState(prevState => ({
                    audio: !prevState.audio,
                  }))
                }
              />
              <Controls
                label={this.state.video ? "Turn off video" : "Turn on video"}
                control={this.state.video ? "videoOn" : "videoOff"}
                isChecked={this.state.video}
                onChange={() =>
                  this.setState(prevState => ({
                    video: !prevState.video,
                  }))
                }
              />
              <Controls
                label="Add Participants"
                control="addParticipants"
                isChecked={this.props.control?.addParticipants}
                onChange={() =>
                  this.props.visitNow?.guest_doctor?.id !== this.id &&
                  this.props.appointment?.guest_doctor_id?.id !== this.id &&
                  (!this.props.appointment?.guest_doctor ||
                    (this.props.appointment?.guest_doctor_status !==
                      "ACCEPTED" &&
                      this.props.appointment?.guest_doctor_status !==
                        "REQUESTED")) &&
                  this.props.changeControl({
                    addParticipants: !this.props.control?.addParticipants,
                    chat: false,
                    notes: false,
                    showVitals: false,
                    prescriptions: false,
                  })
                }
              />
              <Controls
                label={"Leave Call"}
                control="callEnd"
                onChange={() =>
                  this.setState({
                    isLeave: true,
                  })
                }
              />
            </div>
            <AutoCloseMenu
              showMenu={this.props.connected}
              setShowMenu={res => this.props.changeControl({ menu: res })}
              fixedPosition
            >
              {this.props.control?.menu && (
                <div className="dropup">
                  <div className="dropup-content p-2">
                    <button
                      className="button-style float-left p-2"
                      onClick={() => {
                        this.viewProfile();
                        this.props.changeControl({
                          menu: false,
                        });
                      }}
                    >
                      <StartCallIcon type="profile" /> View Patient
                    </button>

                    <button
                      onClick={() => {
                        this.props.clearScreenshots();
                        this.props.noOfUsersConnected > 0 &&
                          this.isPatientJoined() &&
                          this.props.changeControl({
                            takeScreenshot:
                              !this.props?.control?.takeScreenshot,
                            menu: false,
                          });
                      }}
                      className="button-style float-left p-2"
                    >
                      <StartCallIcon type="screenshot" /> Take Screenshot
                    </button>
                    <button
                      className="button-style float-left p-2"
                      onClick={() =>
                        this.props.changeControl({
                          prescriptions: !this.props?.control?.prescriptions,
                          showVitals: false,
                          chat: false,
                          notes: false,
                          addParticipants: false,
                          menu: false,
                        })
                      }
                    >
                      <StartCallIcon type="prescreptions" /> Prescriptions
                    </button>
                    <button
                      className="button-style float-left p-2"
                      onClick={() =>
                        this.props.changeControl({
                          showVitals: !this.props?.control?.showVitals,
                          chat: false,
                          notes: false,
                          addParticipants: false,
                          menu: false,
                          prescriptions: false,
                        })
                      }
                    >
                      <StartCallIcon type="showVitals" /> Show Vitals
                    </button>
                  </div>
                </div>
              )}
              <div className="px-5">
                <Controls
                  control="dots"
                  isChecked={this.props.control?.menu}
                  onChange={() =>
                    this.props.noOfUsersConnected > 0 &&
                    this.props.changeControl({
                      menu: !this.props.control?.menu,
                    })
                  }
                />
              </div>
            </AutoCloseMenu>
          </div>
        )}
      </>
    );
  }
}
const mapStoreToProps = ({ dashboard }) => ({
  control: dashboard.appointments?.control,
  appointment: dashboard.appointments?.schAppointmentDetail,
  visitNow: dashboard?.ongoingAppointment?.visitNow,
  users: dashboard?.ongoingAppointment?.users,
});

const mapDispatchToProps = dispatch => ({
  changeControl: control => dispatch(actions.changeControl(control)),
  setSharedDocuments: (file, cb) =>
    dispatch(actions.setSharedDocuments(file, cb)),
  clearScreenshots: () => dispatch(actions.clearScreenshots()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(Publisher);
